/* eslint-disable import/no-anonymous-default-export */
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  articlesentiment: {
    width: '100%',
    display: 'flex',
    gap: pxToEm(16),
    flexDirection: 'column',
    '& .emojipreview': {
      maxWidth: 'unset',
      minWidth: '240px'
    }
  }
});
